class NsShopByBudget extends HTMLElement {
  connectedCallback() {
    if (this.dataset.nsBudgetReady === 'true') return;
    this.dataset.nsBudgetReady = 'true';
    this.track = this.querySelector('[data-ns-budget-track]');
    this.previousButton = this.querySelector('[data-ns-budget-previous]');
    this.nextButton = this.querySelector('[data-ns-budget-next]');
    this.handleClick = this.handleClick.bind(this);
    this.updateControls = this.updateControls.bind(this);
    this.addEventListener('click', this.handleClick);
    this.track?.addEventListener('scroll', this.updateControls, { passive: true });
    window.addEventListener('resize', this.updateControls, { passive: true });
    requestAnimationFrame(this.updateControls);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.track?.removeEventListener('scroll', this.updateControls);
    window.removeEventListener('resize', this.updateControls);
  }

  handleClick(event) {
    const previous = event.target.closest('[data-ns-budget-previous]');
    const next = event.target.closest('[data-ns-budget-next]');
    if (previous || next) {
      const card = this.track?.querySelector('.ns-budget-card');
      if (!this.track || !card) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 12;
      const distance = card.getBoundingClientRect().width + gap;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: previous ? -distance : distance,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      return;
    }

    const productLink = event.target.closest('[data-ns-budget-product]');
    const bandLink = event.target.closest('[data-ns-budget-band]');
    if (!productLink && !bandLink) return;

    const target = productLink || bandLink;
    const eventName = productLink
      ? 'nidharshana:budget_product_clicked'
      : 'nidharshana:budget_band_clicked';
    const payload = {
      bracket_key: target.dataset.budgetKey || '',
      destination: target.dataset.destination || target.getAttribute('href') || '',
      section_id: this.dataset.sectionId || ''
    };
    if (productLink) {
      payload.product_id = target.dataset.productId || '';
      payload.variant_id = target.dataset.variantId || '';
    }

    try {
      window.Shopify?.analytics?.publish(eventName, payload);
    } catch (error) {
      // Measurement must never interrupt navigation.
    }
  }

  updateControls() {
    if (!this.track || !this.previousButton || !this.nextButton) return;
    const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
  }
}

if (!customElements.get('ns-shop-by-budget')) {
  customElements.define('ns-shop-by-budget', NsShopByBudget);
}
